module.exports = __webpack_public_path__ + "static/media/rotation.8554e5fe.mp3";